<template>
  <section>
    <SpectreWrap justify="center">
      <SpectreWrapItem
        v-for="profile in profiles"
        :key="profile.type"
        class="inline-flex"
      >
        <a
          :href="profile.fullUrl || undefined"
          :aria-label="profile.label"
          class="inline-flex"
        >
          <ConnectionIcon
            :type="profile.type"
            class="size-10"
            :variant="iconStyle === 'grayscale' ? 'monochrome' : 'default'"
          />
        </a>
      </SpectreWrapItem>
    </SpectreWrap>
  </section>
</template>

<script setup lang="ts">
import { SpectreWrap, SpectreWrapItem } from '@agentsoftware/spectre-ui';
import ConnectionIcon from '@/Components/Icons/ConnectionIcon.vue';
import SocialProfileData = App.Data.LinkGroup.SocialProfileData;
import IconStyle = App.Enums.LinkGroup.IconStyle;

defineProps<{
  iconStyle: IconStyle;
  profiles: SocialProfileData[];
}>();
</script>
